import { ECheckAndApplyResultEnum } from "../types"

export const checkAndApplyResultEnumTransactionsData: Record<ECheckAndApplyResultEnum, string> = {
  [ECheckAndApplyResultEnum.OK]: "V pořádku",
  [ECheckAndApplyResultEnum.AlreadyApplied]: "Již aktivováno",
  [ECheckAndApplyResultEnum.UpsellNotAvailable]: "Nezakoupeno"
};